export const delimiter = () => {
  return `<div class="ejs-delimiter"></div>`;
};